/**
 * RMI Form Floating Labels and Tab Order Fix
 */

 const Labels = () => {
  // form wrapper for the nested block
  const formWrapper = document.querySelector('.wp-block-gce-gce-form-builder');

  // Options for the observer (which mutations to observe)
  const config = { childList: true, subtree: true };

  // Callback function to execute when mutations are observed
  const formObserver = function (mutationsList, observer) {
    mutationsList.map(mutation => {
      if (mutation.type === 'childList'
          && mutation.addedNodes[0] && mutation.addedNodes[0].classList.contains('form-builder__content')) {

        //fieldset tag, custom-radios containers, radio inputs, label
        const fieldset = formWrapper.querySelectorAll('.form-group > fieldset');
        const radioButtons = formWrapper.querySelectorAll('.custom-radios');
        const inputs = formWrapper.querySelectorAll('.custom-radios input[type="radio"]');
        const radioLabels = formWrapper.querySelectorAll('.custom-radios label');

        const hiddenTabs = [fieldset, radioLabels, inputs, radioButtons];

        for (const hiddenTab of hiddenTabs) {
          hiddenTab.forEach((element) => element.setAttribute('tabindex', '-1'));

          // input[type=radio]
          if (hiddenTab === inputs) {
            hiddenTab.forEach((element) => element.setAttribute('tabindex', '0'));
          }
        }

        // lastly; stop observing
        observer.disconnect();
      }
    });
  }

  if (formWrapper) {
    // Create an observer instance
    const observer = new MutationObserver(formObserver);

    // Start observing the form wrapper for configured mutations
    observer.observe(formWrapper, config);
  }
};

export default Labels;
